// app/javascript/controllers/flash_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Set position based on scroll state
    this.positionFlash();

    // Hide flash after 5 seconds
    setTimeout(() => {
      this.element.classList.add("opacity-0");
      setTimeout(() => this.element.remove(), 500);
    }, 5000);

    // Handle scroll events
    this.scrollHandler = this.positionFlash.bind(this);
    window.addEventListener("scroll", this.scrollHandler);
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler);
  }

  positionFlash() {
    // Position at top of viewport when scrolled
    const scrollY = window.scrollY;
    if (scrollY > 0) {
      this.element.classList.add("fixed", "top-0", "left-0", "right-0");
      this.element.classList.remove("relative");
    } else {
      this.element.classList.remove("fixed", "top-0", "left-0", "right-0");
      this.element.classList.add("relative");
    }
  }

  close() {
    this.element.remove();
  }
}